import Vue from 'vue';

import App from './App';
import router from './router';
import createStore from './store';

// Plugins
import './plugins/nprogress';
import './plugins/element-ui';
import './plugins/v-lazy-image';
import './plugins/vue-mq';
import './plugins/font-awesome';
import './plugins/vue-resource';
import './plugins/vue-js-modal';
import './plugins/svg-sprite';
import './plugins/vee-validate';

// Global components
import './components';

Vue.config.productionTip = false;

const store = createStore();

document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-new
  new Vue({
    el: '#app',
    components: { App },
    data: {
      sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    },
    router,
    template: '<App/>',
    store,
  });
});



// WEBPACK FOOTER //
// ./src/main.js